import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { isMdOrLess } from 'helpers/detect-md';
import { stableSort, getSorting, getSortIcon } from 'helpers/utils';

import {
  Divider,
  HighlightText,
} from 'components';

const thresholdNext = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
};
// show table for windows & mobile view
class SmartTable extends Component {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    fieldsMobile: PropTypes.arrayOf(PropTypes.shape({})),
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    notMobile: PropTypes.bool,
    rowClassName: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
    ]),
    searchText: PropTypes.string,
    style: PropTypes.shape({}),
    threshold: PropTypes.string,
    sortableFields: PropTypes.arrayOf(PropTypes.string),
    statusColorRed: PropTypes.bool,
    isSetting: PropTypes.bool,
    isInvoiceDetail: PropTypes.bool,
    isRetailPage: PropTypes.bool,
    isCartDialog: PropTypes.bool,
  }
  static defaultProps = {
    fieldsMobile: null,
    notMobile: false,
    rowClassName: '',
    searchText: '',
    style: {},
    threshold: 'md',
    sortableFields: [],
    statusColorRed: false,
    isSetting: false,
    isInvoiceDetail: false,
    isRetailPage: false,
    isCartDialog: false
  };

  state = {
    order: 'asc',
    orderBy: '',
  }

  onClickSort = (event, property) => {
    const { order, orderBy } = this.state;
    let orderRule = 'desc';

    if (orderBy === property && order === 'desc') {
      orderRule = 'asc';
    }
    this.setState({ order: orderRule, orderBy: property });
  }
  render() {
    const {
      fields,
      style,
      searchText,
      fieldsMobile,
      data,
      notMobile,
      rowClassName,
      threshold,
      sortableFields,
      statusColorRed,
      isSetting,
      isInvoiceDetail,
      isRetailPage,
      isCartDialog
    } = this.props;
    const { order, orderBy } = this.state;
    return (
      <div
        className="smart-table"
        style={style}
      >
        {
          !isMdOrLess && <Table
          className={notMobile ? '' : `d-${threshold}-down-none`}
          style={{ backgroundColor: 'transparent' }}
          >
            <TableHead
            style={{display: isCartDialog ? 'none': ''}}
            >
              <TableRow>
                {fields.map(field => (
                  !field.mobileShow &&
                  <TableCell
                    colSpan={field.colSpan || 1}
                    key={field.name}
                    className={field.classNameForHeader}
                    sortDirection={orderBy === field.name ? order : false}
                  
                  >
                    {field.label && sortableFields.includes(field.name) ? (
                      <Tooltip
                        title="Sort"
                        enterDelay={300}
                      >
                        <TableSortLabel
                          onClick={event => this.onClickSort(event, field.name)}
                        >
                          {field.label}
                          {getSortIcon(
                            [
                              [
                                field.name,
                                orderBy === field.name ? order : null,
                              ],
                            ],
                            field.name,
                          )}
                        </TableSortLabel>
                      </Tooltip>
                    ) : field.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                stableSort(data, getSorting(order, orderBy))
                .map((row, rowIndex) => {
                  const rowRed = Math.floor(parseFloat(row.availableQuantity)) === 0 ||
                    Math.floor(parseFloat(row.availableQuantity)) < Math.floor(parseFloat(row.qty)) ? 'row-red' : '';
                  const className = typeof rowClassName === 'function' ? rowClassName(row, rowIndex) : rowClassName;
                  const strikeoutRow = isInvoiceDetail && row.quantity === 0 ? 'strikeout' : '';

                  return (
                    <TableRow
                      className={`${className} ${rowRed} ${strikeoutRow}`}
                      key={`${row.id}-${rowIndex}`}
                    >
                      {
                        fields.map((field, index) => {
                          // get value from render function
                          const value = field.render ? field.render(row, rowIndex, field) : (row.isSeparator ? '' : row[field.name]);
                          const title = field.title ? (
                            typeof field.title === 'function' ? field.title(row) : field.title
                          ) : typeof value === 'object' ? row[field.name] : value;
                          const searchedValue = !field.searchDisabled && !field.render && searchText
                            ? <HighlightText text={value} highlight={searchText} /> : value;
                          let className = field.overflowHidden ? 'overflow-hidden' : typeof field.className === 'function' ? field.className(row) : field.className ? field.className : '';
                          className += (field.name === 'status' && statusColorRed) ? 'status-red' : '';
                          className = className !== '' ? className : undefined;
                          const colSpan = typeof field.colSpan === 'function' ? field.colSpan(row) : field.colSpan;
                          const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;
                          const cellClassName = typeof field.cellClassName === 'function' ? field.cellClassName(row) : field.cellClassName;

                          return (!field.mobileShow &&
                          <TableCell
                            colSpan={colSpan || 1}
                            key={index}
                            title={field.noTitle || isEmpty || !title ? '' : title.toString()}
                            className={cellClassName}
                            style={{ position: 'relative'}}
                          >
                            <div className={className} >
                              {!isEmpty && searchedValue}
                            </div>
                          </TableCell>
                          );
                        })
                      }
                    </TableRow>
                  );
                })
              }
            </TableBody>
          </Table>
        }
        {
          isMdOrLess && (
            <div className={`d-${thresholdNext[threshold]}-up-none`}>
              {
                data.map((row, index) => (
                  <div key={`${row.id}-${index}`}>
                    {!!index && <Divider />}
                    <div className={`table-card ${isSetting ? 'address-mobile' : ''}`}>
                      {
                        (fieldsMobile || fields).map((field) => {
                          const value = field.render ? field.render(row, index, field) : (row.isSeparator ? '' : row[field.name]);
                          const searchedValue = !field.searchDisabled && !field.render && searchText
                            ? <HighlightText text={value} highlight={searchText} /> : value;
                          const className = typeof field.className === 'function' ? field.className(row) : field.className;
                          const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;
                          const label = isSetting && (field.label) ?
                            <div className="label">{(field.name !== 'state') ? field.label : undefined}</div> :
                            undefined;
                          let cardItemClass = `card-item ${field.mobileHidden || isEmpty || (field.mobileShow && !field.mobileShow) ? 'd-md-down-none' : ''}`;
                          if (isSetting && field.type && field.type === 'controlBtns') {
                            cardItemClass += 'card-item-controls';
                          }


                          return (
                            <div className={'card-item-group normal'}>
                              <div
                                className={cardItemClass}
                                key={field.name}
                              >
                                <div className="value">
                                  { label }
                                  <div className={className} style={isSetting ? { width: field.name === 'zipcode' ? '58px' : 'calc(100% - 75px)' } : {}}>{searchedValue}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          )
        }
      </div>
    );
  }
}


export default SmartTable;
